import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './Containers/App';
import { enableES5 } from 'immer';

enableES5();

export const main = function (options) {
  const el = document.querySelector(
    `[data-crmform-workshops-footer="${options.id}"]`
  );
  if (!el) return;
  ReactDOM.render(<App {...options} />, el);
};
